<form #formElement="ngForm">
  <div class="card p-3 my-3">
    <app-accordion class="w-100 form-container">
      <app-panel [title]="'Información general'" class="w-100" [titleFirts]="true" id="general-info" [opened]="true">
        <div class="form-group">
          <app-incident-general-info
          [(ngModel)]="incidentFileData"
          name="jsonData"
          [incidentTypeFullList]="_incidentTypeFullList"
          [incidentSubTypeFullList]="_incidentSubTypeFullList"
          [incidentCategoryColorList]="incidentCategoryColorList"
          [isIncidentFile]="true"
          ></app-incident-general-info>
        </div>
      </app-panel>
      <app-panel [title]="'Datos de localización'" class="w-100" [titleFirts]="true" id="location-info" [opened]="true">
        <app-incident-location-ref
        [(ngModel)]="incidentFileData"
        name="jsonData"
        [readonly]="true"
        [vialAxesFullList]="_vialAxesFullList"
        [roadwayFullList]="_roadwayFullList"
        [trafficDirectionsFullList]="_trafficDirectionsFullList"
        [sectorFullList]="_sectorFullList"
        [subSectorFullList]="_subSectorFullList"
        ></app-incident-location-ref>
      </app-panel>
      <app-panel [title]="'Datos Ficha Emergencia'" class="w-100" [titleFirts]="true" id="file-info" [opened]="true">
        <div class="form-container">
          <div class="form-group">
            <label for="fatalVictims">Victimas Fatales</label>
            <custom-select
              [(ngModel)]="_fatalVictims"
              [bordered]="true"
              name="fatalVictims"
              id="fatalVictims"
              [(sourceList)]="_fatalVictimsList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="tracksAffected">¿Afecta más de 1 pista?</label>
            <custom-select
              [(ngModel)]="_tracksAffected"
              [bordered]="true"
              name="tracksAffected"
              id="tracksAffected"
              [(sourceList)]="_tracksAffectedList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="byPass">By pass</label>
            <custom-select
              [(ngModel)]="_byPass"
              [bordered]="true"
              name="byPass"
              id="byPass"
              [(sourceList)]="_byPassList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="trafficCut">Corte de tránsito</label>
            <custom-select
              [(ngModel)]="_trafficCut"
              [bordered]="true"
              name="trafficCut"
              id="trafficCut"
              [(sourceList)]="_trafficCutList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="initHour">Hora incio Corte</label>
            <input
              type="tel"
              class="form-control"
              id="initHour"
              name="initHour"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="endHour">Hora fin Corte</label>
            <input
              type="tel"
              class="form-control"
              id="endHour"
              name="endHour"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="accidentType">Tipo de Accidente</label>
            <custom-select
              [(ngModel)]="_accidentType"
              [bordered]="true"
              name="accidentType"
              id="accidentType"
              [(sourceList)]="_accidentTypeList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="relativeLocation">Ubicación Relativa</label>
            <custom-select
              [(ngModel)]="_relativeLocation"
              [bordered]="true"
              name="relativeLocation"
              id="relativeLocation"
              [(sourceList)]="_relativeLocationList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="hardPoint">Punto Duro</label>
            <custom-select
              [(ngModel)]="_hardPoint"
              [bordered]="true"
              name="hardPoint"
              id="hardPoint"
              [(sourceList)]="_hardPointList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="roadDefenses">Defensas Caminera</label>
            <custom-select
              [(ngModel)]="_roadDefenses"
              [bordered]="true"
              name="roadDefenses"
              id="roadDefenses"
              [(sourceList)]="_roadDefensesList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="unevenness">Desnivel en la Faja</label>
            <custom-select
              [(ngModel)]="_unevenness"
              [bordered]="true"
              name="unevenness"
              id="unevenness"
              [(sourceList)]="_unevennessList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="fenceState">Estado Cerco</label>
            <custom-select
              [(ngModel)]="_fenceState"
              [bordered]="true"
              name="fenceState"
              id="fenceState"
              [(sourceList)]="_fenceStateList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="roadWorks">Trabajos en la vía</label>
            <custom-select
              [(ngModel)]="_roadWorks"
              [bordered]="true"
              name="roadWorks"
              id="roadWorks"
              [(sourceList)]="_roadWorksList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="maximumSectorSpeed">Velocidad Máxima Sector</label>
            <custom-select
              [(ngModel)]="_maximumSectorSpeed"
              [bordered]="true"
              name="maximumSectorSpeed"
              id="maximumSectorSpeed"
              [(sourceList)]="_maximumSectorSpeedList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="roadCondition">Condición Calzada</label>
            <custom-select
              [(ngModel)]="_roadCondition"
              [bordered]="true"
              name="roadCondition"
              id="roadCondition"
              [(sourceList)]="_roadConditionList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="atmosphericState">Estado Atmosférico</label>
            <custom-select
              [(ngModel)]="_atmosphericState"
              [bordered]="true"
              name="atmosphericState"
              id="atmosphericState"
              [(sourceList)]="_atmosphericStateList"
              required
            ></custom-select>
          </div>  
          <div class="form-group">
            <label for="luminosityState">Estado Luminosidad</label>
            <custom-select
              [(ngModel)]="_luminosityState"
              [bordered]="true"
              name="luminosityState"
              id="luminosityState"
              [(sourceList)]="_luminosityStateList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="artificialLight">Luz Artificial</label>
            <custom-select
              [(ngModel)]="_artificialLight"
              [bordered]="true"
              name="artificialLight"
              id="artificialLight"
              [(sourceList)]="_artificialLightList"
              required
            ></custom-select>
          </div>
          <div class="form-group">
            <label for="probableCause">Causa Probable</label>
            <custom-select
              [(ngModel)]="_probableCause"
              [bordered]="true"
              name="probableCause"
              id="probableCause"
              [(sourceList)]="_probableCauseList"
              required
            ></custom-select>
          </div>
        </div>

      </app-panel>
      <app-panel [title]="'Detalle'" class="w-100" [titleFirts]="true" id="details" [opened]="true">
        <div class="form-container">
          <div class="form-group" style="min-width: 100%;">
            <label for="description">Dinámica del accidente</label>
            <textarea
              type="text"
              maxlength="500"
              name="description"
              rows="3"
      
              class="form-control"
              id="description"
              [placeholder]="'Detalles'"
            ></textarea>
          </div>
        </div>
      </app-panel>
    </app-accordion>

    <section class="w-100 container px-0 my-2">
      <app-incident-tables
      [incidentFileData]="incidentFileData"
      [displayOnModal]="true"
      [incidentID]="incidentID"
      [vialAxes]="incidentFileData?.VialAxisID"
      [incidentClose]="(incidentFileData?.DateTimeClosed?.Date?.Day)"
      [loadAssistances]="loadAssistances"
      [loadDataLanes]="loadDataLanes"
      [loadDataVehicles]="loadDataVehicles"
      [loadDataPersons]="loadDataPersons"
      [loadAddVehicles]="loadAddVehicles"
      [loadAddPersons]="loadAddPersons"
      [displayOnIncidentFile]="true">
    </app-incident-tables>
    </section>

    <app-accordion class="w-100 form-container">
      <app-panel [title]="'Judicial'" class="w-100" [titleFirts]="true" id="judicial" [opened]="true">
        <div class="form-container">
          <div class="form-group">
            <label for="constancy">Constancia</label>
            <input
              type="text"
              class="form-control"
              id="constancy"
              name="constancy"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="complaint">Denuncia</label>
            <input
              type="text"
              class="form-control"
              id="complaint"
              name="complaint"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="paragraph">Párrafo</label>
            <input
              type="text"
              class="form-control"
              id="paragraph"
              name="paragraph"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="folio">Folio</label>
            <input
              type="text"
              class="form-control"
              id="folio"
              name="folio"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="partNumber">Número de parte</label>
            <input
              type="number"
              class="form-control"
              id="partNumber"
              name="partNumber"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <lib-datepicker
            [labelText]="'Fecha de citación'"
            name="citationDate"
            id="citationDate"
            [useTime]="false"
            ></lib-datepicker>
          </div>
          <div class="form-group">
            <label for="citationHour">Hora citación</label>
            <input
              type="tel"
              class="form-control"
              id="citationHour"
              name="citationHour"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="originCarabinieri">Procedencia Carabinero</label>
            <input
              type="text"
              class="form-control"
              id="originCarabinieri"
              name="originCarabinieri"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="nameCarabinieri">Nombre Carabinero</label>
            <input
              type="text"
              class="form-control"
              id="nameCarabinieri"
              name="nameCarabinieri"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="fono">Fono Carabinero</label>
            <input
              type="text"
              class="form-control"
              id="fono"
              name="fono"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="witness1">Testigo 1</label>
            <input
              type="text"
              class="form-control"
              id="witness1"
              name="witness1"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="witness2">Testigo 2</label>
            <input
              type="text"
              class="form-control"
              id="witness2"
              name="witness2"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
        </div>
      </app-panel>
      <app-panel [title]="'Responsables Emergencia'" class="w-100" [titleFirts]="true" id="responsibles" [opened]="true">
        <div class="form-container">
          <div class="form-group">
            <label for="operator">Operador</label>
            <input
              type="text"
              class="form-control"
              id="operator"
              name="operator"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
          <div class="form-group">
            <label for="supervisor">Supervisor</label>
            <input
              type="text"
              class="form-control"
              id="supervisor"
              name="supervisor"
              lang="en"
              pattern="^([.]?[0-9.]+)"
              required/>
          </div>
        </div>
      </app-panel>
    </app-accordion>
    <section class="w-100 container px-0 my-2">
      <app-incident-tables
      [incidentFileData]="incidentFileData"
      [displayOnModal]="true"
      [incidentID]="incidentID"
      [displayOnlyFileEvidence]="true">
    </app-incident-tables>
    </section>
  </div>
</form>

<app-incident-element-modal
  #elementModal
  (onClose)="onCloseSettings($event)"
  [data]="incidentElements ? incidentElements : null"
  (dataChange)="saveDataElements($event)"
></app-incident-element-modal>


